import React from 'react'
import { cn } from '@/shared/lib/utils'

export interface FeatureEmptyStateProps {
    icon?: React.ReactNode
    title: string
    description: React.ReactNode
    children?: React.ReactNode
    className?: string
}

export const FeatureEmptyState = ({
    icon,
    title,
    description,
    children,
    className
}: FeatureEmptyStateProps) => {
    return (
        <div className={cn(
            "relative flex flex-col items-center justify-center text-center p-8 border-dashed border rounded-lg",
            className
        )}>
            {icon && (
                <div className="h-24 w-24 bg-primary/10 rounded-full flex items-center justify-center mb-6 animate-pulse">
                    {icon}
                </div>
            )}
            <div className="space-y-2 mb-8">
                <h2 className="text-2xl font-bold tracking-tight">
                    {title}
                </h2>
                <p className="text-muted-foreground max-w-md mx-auto">
                    {description}
                </p>
            </div>
            {children && (
                <div className="flex flex-col items-center gap-4 w-full">
                    {children}
                </div>
            )}
        </div>
    )
}
